import { Tooltip, Typography } from "antd";
import React, { useState } from "react";
import styled from "styled-components";
import check from "../../../../assets/img/icons/tick-white.svg";
import Checkbox from "modules/Common/Components/Checkbox";
import { IAccountItem } from "modules/Content/interfaces";
import { backgroundColorParsing, parseColorGradients } from "../utils";

interface IAccountCompany {
  account: IAccountItem;
  handleAccountSelection: any;
  checked: boolean;
  hideSelected?: boolean;
}
const { Paragraph } = Typography;
const AccountCompany: React.FC<IAccountCompany> = (props: IAccountCompany) => {
  const { account, handleAccountSelection, checked, hideSelected = false } = props;
  const [ellipsisState, setEllipsisState] = useState(false);
  return (
    <CompanyCardStyle
      className={props.account.state}
      personality={backgroundColorParsing(account.accountPersonality)}
    >
      <div className={"checked-card"}>
        {checked && (
          <Checkbox
            checked={true}
            onClick={() => handleAccountSelection(account, !checked ? "disabled-company" : "selected")}
            borderless={true}
            width={"20px"}
            height={"20px"}
            onChange={() => {}}
          />
        )}
      </div>

      <div
        className="wrapper padding-sm"
        onClick={() =>
          handleAccountSelection(account, account.state === "selected" ? "disabled-company" : "selected")
        }
      >
        <span className="check-status"></span>
        <div className="logo-bg" style={{ backgroundImage: `url(${account.accountLogo})` }}></div>
        <img src={account.accountLogo} alt={account.accountName} />
        <div
          className="puls-line"
          style={{
            backgroundColor: `${parseColorGradients(account.accountPulse)}`,
            background: `linear-gradient(to right, ${parseColorGradients(account.accountPulse)})`,
          }}
        ></div>
      </div>
      <span className={`selected-label ${hideSelected ? "no-display" : ""}`}>Selected</span>
      <div className="company-name">
        <h5>
          <Tooltip title={ellipsisState ? account.accountName : undefined}>
            <Paragraph className={`comp-tooltip`} ellipsis={{ onEllipsis: setEllipsisState }}>
              {account.accountName}
            </Paragraph>
          </Tooltip>
        </h5>
        <div className="followers">
          {account.accountShare && account.accountShare !== "N/A" && (
            <span>
              {account.accountTicker}: ${parseFloat(account.accountShare).toFixed(2)}
            </span>
          )}
          {account.accountSubscribers && <span>{account.accountSubscribers} followers</span>}
        </div>
      </div>
    </CompanyCardStyle>
  );
};

const CompanyCardStyle = styled.div<{ personality?: string }>`
  position: relative;
  text-align: center;
  display: inline-block;
  float: left;
  margin: 0 7px 5px 7px;
  .wrapper {
    width: 250px;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    box-shadow: rgb(0 0 0 / 8%) 0px 4px 12px;
    padding-bottom: 34px;
    position: relative;
    border: 4px solid #fff;
    padding: 10px 50px 15px 50px;
    transition: 0.5s;
    cursor: pointer;
    margin-bottom: 5px;
    background-color: #fff;
    /* @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      border-radius: 12px;
    } */
    .puls-line {
      width: calc(100% - 44px);
      height: 5px;
      border-radius: 4px;
      left: 22px;
      position: absolute;
      bottom: 14px;
      z-index: 4;
    }
    &:before {
      content: "";
      position: absolute;
      top: -4px;
      left: -4px;
      width: calc(100% + 8px);
      height: calc(100% + 8px);
      border-radius: 12px;
      z-index: 2;
      background: conic-gradient(from -60deg, ${(props) => props.personality} 360deg);
      /* This background value will be replaced with props */
      /* @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        border-radius: 12px;
      } */
    }
    &:after {
      content: "";
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
      background-color: #fff;
      border-radius: 10px;
      z-index: 2;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        border-radius: 8px;
      }
    }
    .logo-bg {
      background-repeat: no-repeat;
      background-size: contain;
      width: 100%;
      height: calc(100% - 22px);
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      background-position: center;
      z-index: 3;
      margin-bottom: 22px;
    }
    img {
      height: 120px;
      max-width: 120px;
      margin: 0 auto;
      opacity: 0;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 100px;
      }
    }
    .check-status {
      background-color: rgba(255, 255, 255, 0.4);
      border: 2px solid rgb(255, 255, 255);
      box-shadow: rgba(0, 0, 0, 0.23) 0px 0px 6px 2px;
      height: 22px;
      width: 22px;
      border-radius: 22px;
      position: absolute;
      top: 12px;
      left: 12px;
      transition: 0.5s;
      z-index: 9;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 15px;
        width: 15px;
      }
    }
  }
  .selected-label {
    background-color: rgb(235, 119, 25);
    border-radius: 14px;
    font-size: 14px;
    color: rgb(255, 255, 255);
    font-family: "robotobold";
    font-weight: 700;
    padding: 0px 15px;
    margin: 0 auto;
    transition: 0.5s;
    opacity: 0;
    visibility: hidden;
    background-repeat: no-repeat;
    background-position: center;
    &.no-display {
      display: none;
    }
  }
  &.selected {
    .wrapper {
      border: 4px solid rgb(235, 119, 25);
      .check-status {
        background-image: url(${check});
        background-color: rgb(235, 119, 25);
        border-color: rgb(235, 119, 25);
        background-repeat: no-repeat;
        background-position: 4px 5px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          background-position: 2px 3px;
          background-size: 7px;
        }
      }
    }
    .selected-label {
      opacity: 1;
      visibility: visible;
    }
  }
  &.disabled-company {
    opacity: 0.5;
    .wrapper {
      cursor: default;
    }
  }
  .checked-card {
    position: absolute;
    z-index: 10;
    top: 15px;
    left: 17px;
    width: auto !important;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      top: 11px;
      left: 13.5px;
    }
  }
  .company-name {
    min-height: 46px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      min-height: 36px;
    }
    h5 {
      font-size: 18px;
      color: #424b50;
      font-family: "Roboto Slab";
      font-weight: 800;
      line-height: 1.111;
      letter-spacing: -0.45px;
      margin-bottom: 5px;
      text-align: left;
      margin-left: 10px;
      /* min-height: 36px; */
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-word;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 13px;
        line-height: 15px;
        /* min-height: 32px; */
      }

      .comp-tooltip {
        margin-bottom: 0;
      }
    }
    .followers {
      display: flex;
      span {
        font-family: Roboto;
        letter-spacing: -0.75px;
        font-size: 11px;
        color: #7e7e7e;
        font-weight: 500;
        line-height: 1.8;
        margin-left: 10px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 9px;
        }
      }
    }
  }
`;

export default AccountCompany;

// AccountCompany.defaultProps = {
//   account: {
//     account_logo:
//       "https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/SAP_2011_logo.svg/1024px-SAP_2011_logo.svg.png",
//     account_name: "Account name",
//     pulsColor: "rgb(126, 214, 255) 20%, rgb(245, 146, 35) 20%, rgb(245, 146, 35) 40%, rgb(246, 140, 173) 40%, rgb(246, 140, 173) 80%, rgb(184, 62, 120) 80%, rgb(184, 62, 120) 100%",
//     bgColor: "rgb(79, 211, 154) 45deg, rgb(255, 178, 54) 135deg, rgb(81, 180, 224) 225deg, rgb(237, 89, 68) 315deg,  rgb(79, 211, 154) 360deg",
//   },
// };
